module.exports = __webpack_public_path__ + "tables/media/Core_filled.c2473ccc.svg";